import { Source, Layer } from 'react-map-gl/maplibre'
import type { FilterSpecification } from 'maplibre-gl'
import { useAppStore, usePMTiles } from '~/hooks'

import {
  FLOOD_TILE_ADAPTATION,
  FLOOD_TILE_DEM,
  FLOOD_TILE_RETURN_PERIOD,
  FLOODPLAINS_SOURCES,
  LayerId,
  SCENARIO_LESS_BAD_FILL_COLOR,
  VisibleLayers,
  type AdaptationCode,
} from '~/constants'

function FloodLayer() {
  const { sources, layerInfo } = usePMTiles()
  const { layerVisibility, dataset, returnPeriod, DEM, adaptation, contourFloodEnabled } =
    useAppStore()

  const floodOn = dataset === 'cosmos' && layerVisibility[VisibleLayers.FLOOD]
  // ponytail: keep layout.visible so MapLibre continues to cache tiles; hide via opacity
  // (visibility:none tends to drop/reload tiles on each Extent↔Depth toggle).
  const active = floodOn && !contourFloodEnabled

  const filter =
    returnPeriod && DEM && adaptation
      ? ([
          'all',
          ['==', ['get', 'adaptation'], FLOOD_TILE_ADAPTATION[adaptation as AdaptationCode]],
          ['==', ['get', 'dem'], FLOOD_TILE_DEM[DEM as keyof typeof FLOOD_TILE_DEM]],
          [
            '==',
            ['get', 'return_period'],
            FLOOD_TILE_RETURN_PERIOD[returnPeriod as keyof typeof FLOOD_TILE_RETURN_PERIOD],
          ],
        ] as FilterSpecification)
      : (['literal', false] as FilterSpecification)

  if (!layerInfo) return null

  return (
    <>
      {FLOODPLAINS_SOURCES.map((source) => {
        const url = sources[source]
        const sourceLayer = layerInfo[source]?.[0]?.layer
        if (!url || !sourceLayer) return null

        return (
          <Source key={source} id={source} type="vector" url={`pmtiles://${url}`}>
            <Layer
              id={`${source}-fill`}
              source={source}
              source-layer={sourceLayer}
              type="fill"
              beforeId={LayerId.BUILDING}
              filter={filter}
              layout={{ visibility: floodOn ? 'visible' : 'none' }}
              paint={{
                'fill-color': SCENARIO_LESS_BAD_FILL_COLOR,
                'fill-opacity': active ? 0.5 : 0,
              }}
            />
          </Source>
        )
      })}
    </>
  )
}

export default FloodLayer
